import { Component, ElementRef, signal, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'rt-dialog-toolbar',
  styleUrls: ['./dialog-toolbar.component.less'],
  template: `
    <div class="title">
      <ng-content select="[title]" />
    </div>
    <div class="actions">
      <ng-content select="[actions]" />
    </div>
  `,
  host: {
    '[class.active]': 'active()',
    '[class.radius-top]': 'hasRadiusTop()',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class DialogToolbarComponent {
  public readonly active = input<boolean>(undefined!);

  public hasRadiusTop = signal(true);

  constructor(public elementRef: ElementRef) {}
}
